import { render, staticRenderFns } from "./top-products.vue?vue&type=template&id=1e9125ea&"
import script from "./top-products.vue?vue&type=script&lang=js&"
export * from "./top-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports